import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS, Languages } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { PageHeader } from 'components/PageHeader';
import { useUserStore } from 'stores/user';
import { ChangePassword } from './components/ChangePassword';
import { Preferences } from './components/Preferences';
import { ProfileIllustration } from './components/ProfileIllustration';
import { ProfileSummary } from './components/ProfileSummary';

export const Profile = (): React.ReactElement | null => {
  const { t: tCommon } = useTranslation(LOCIZE_NS.COMMON);
  const { t } = useTranslation(LOCIZE_NS.PROFILE);
  const user = useUserStore(state => state.user);
  const companyImageUrl = user?.imageURL?.trim();
  const languageValue = (user?.appLanguage as Languages) || Languages.Spanish;
  const enterpriseCode = user?.cif || user?.nif;
  const userName =
    user?.firstName && user?.surname
      ? `${user.firstName} ${user.surname}`
      : user?.name || user?.nickname;

  if (!user) {
    return null;
  }

  return (
    <div className="flex flex-col gap-12">
      <PageHeader title={t('Profile.heading')} description={t('Profile.description')} />
      <Card variant="primary" className="p-0 am-md:p-0 -mt-4">
        <div className="flex min-h-44 items-center px-8 py-4">
          <ProfileIllustration companyImageUrl={companyImageUrl} />
          <ProfileSummary
            userName={userName ?? ''}
            email={user.email}
            enterpriseCode={enterpriseCode}
            languageValue={languageValue}
            tCommon={tCommon}
          />
        </div>
      </Card>
      <Preferences />
      <ChangePassword />
    </div>
  );
};
